import axios from "axios";
import { configUrl } from "config.js";
import { LoginContext } from "contexts/LoginContext";
import { useContext } from "react";
import { useQuery } from "react-query";


export default function useGetAllObjective(configType, isActive, isContentProvider) {

  const { providerType } = useContext(LoginContext)
  return useQuery("GetAllObjective", async () => {
    if (configType == null) {
      console.log(configType);
      return null;
    }
    if (isActive == undefined || isActive == "") {
      isActive = false;
    }
    if ((providerType == 1 || providerType == 3) && isContentProvider != false) {
      isContentProvider = true;
    }
    if (isContentProvider == undefined) {
      isContentProvider = false;
    }
    let response = await axios.get(
      `${configUrl.AssessmentServer}/api/DemoghraphicInformation/${configType}/${isContentProvider}/${isActive}/${true}`
    );
    return response.data["$values"];
  },
    {
      staleTime: 1000 * 60 * 5,
    });
}
